export const ArrayFlatten = <T>(arr: any[]) => arr.reduce((acc, val) => acc.concat(val), [] as T[]);